<template>
  <v-container>
    <v-card :loading="loading">
      <v-card-title>Geschiedenis</v-card-title>
      <v-card-text>
        <v-date-picker
          v-model="date"
          color="light-green darken-3"
          full-width
          class="mt-4"
          locale="nl-be"
          :value="computedDateFormattedMomentjs"
          :allowed-dates="allowedDates"
        ></v-date-picker>

        <v-divider></v-divider>
        <v-simple-table>
          <tbody>
            <tr
              v-for="order in orders"
              :key="order.id"
              @click="openOrder(order)"
            >
              <td>{{ order.name }}</td>
              <td class="text-xs-right">{{ order.box_amount }}</td>
            </tr>
            <tr v-if="orders.length == 0">
              <td colspan="2" class="text-center">
                Geen bestellingen op deze datum
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-btn
        fab
        color="primary"
        :disabled="orders.length == 0"
        target="_blank"
        :href="'/printout/' + date"
        fixed
        bottom
        right
      >
        <v-icon>mdi-printer</v-icon></v-btn
      >
    </v-card>
    <OrderDetails
      :visible="dialogs.details"
      @close="dialogs.details = false"
      :order="selectedItem"
      @refresh="fetchOrders"
    />
  </v-container>
</template>

<script>
import OrderDetails from "@/components/OrderDetails";
import { firestore } from "firebase";
import moment from "moment";

export default {
  data() {
    return {
      date: "",
      orders: [],
      dialogs: {
        details: false,
      },
      selectedItem: {},
      loading: false,
    };
  },
  watch: {
    date: "fetchOrders",
  },
  mounted() {
    this.findFirstDate();
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.date
        ? moment(this.date).lang("nl").format("dddd, MMMM Do YYYY")
        : "";
    },
  },
  components: {
    OrderDetails,
  },
  methods: {
    findFirstDate() {
      let now = moment().format("YYYY-MM-DD");
      for (var i = 0; i <= 14; i++) {
        if (this.allowedDates(now)) {
          this.date = now;
          break;
        } else {
          now = moment(now, "YYYY-MM-DD").add(1, "day").format("YYYY-MM-DD");
        }
      }
    },
    openOrder(order) {
      this.selectedItem = order;
      this.dialogs.details = true;
    },
    async fetchOrders() {
      let _self = this;
      this.loading = true;
      let orders = await firestore()
        .collection("Orders")
        .where("concept", "==", false)
        .where("saleDate", "==", this.date)
        .get();
      _self.orders = [];
      orders.forEach((order) => {
        _self.orders.push({
          id: order.id,
          ...order.data(),
        });
      });
      this.loading = false;
    },
    allowedDates(date) {
      let sd = [2, 4, 5];

      let checkDate = moment(date, "YYYY-MM-DD");
      return sd.includes(checkDate.day());
    },
  },
};
</script>

<style>
</style>